module.exports = __webpack_public_path__ + "static/7-e135a5fb70ba3a7da8782f3d0af4351c.mp4";